<template>
  <div class="joinprediv" :class="[saveFlag||showFlag||photoFlag||payShow ? 'noscroll':'']">
    <div v-if="is_back===1" class="info">
      <div class="infotitle">照片被审核者第{{refund_amount}}次打回</div>
      打回原因：{{reason}}
    </div>
    <img v-if="imgbgurl" class="imgurl" :src="imgbgurl" />
    <div v-if="!imgbgurl" class="imgurlwrap" :style="{'background-image':'linear-gradient(to bottom,#' + bgcolor.s_color +',#' +bgcolor.e_color+')'}">
      <img class="imgimg" :src="imgurl" />
    </div>
    <div class="desc">{{desc}}</div>
    <div class="foot">
      <p v-if="payBol" class="saveP">长按照片保存至手机相册</p>
      <button v-if="payBol&&is_back===1&& teamState!=='已结束'" class="retry" @click="rephoto">重新拍摄</button>
      <div v-if="payBol&&is_back===1&& teamState!=='已结束'" class="kong"></div>
      <button v-if="payBol" class="downbtn" @click="openflag">高清下载证件照</button>
      <button v-if="!payBol&&desc" class="retry" @click="showFlag=true">修改信息</button>
      <div v-if="!payBol&&desc" class="kong"></div>
      <button v-if="!payBol" class="downbtn" @click="payOrder">保存电子照</button>
    </div>
    <save-ele :showFlag="saveFlag"
              v-if="payBol"
              :extract_str="extract_str"
              :finalName="[imgbgurl]"
              :isCollect="true"
              :orderid="id"
              downurl="www.id-photo-verify.com/t2"
              :printName="print_pic_name"
              @onCloseEleSave="saveFlag = false"></save-ele>
    <tq v-if="showFlag" :modifyBol="modifyBol" :team="selObj" :noops="noops" @onGoPhoto="onGoPhoto" @onCloseWrap="onCloseWrap" @onHandleInfo="onHandleInfo"></tq>
    <photo :showFlag="photoFlag"
            v-if="payBol"
           :collectInfo="selObj"
           @onControlPhoto="photoFlag=false"
           @onRruleDetail="photoFlag=false"></photo>
    <pay :showFlag="payShow"
         v-if="!payBol"
         @onClosePay="payShow=false"
         :imgurl="imgurl"
         :specName="selObj.spec_name"
         :canprint="false"
         :price="price"
         :chooseColor="[bgcolor]"
         :allColor="[bgcolor]"
         @onChooseClose="onChooseClose"
         :project_no="project_no"
         :chooseKey="chooseKey"
         @onGetjoindetail="getjoindetail"></pay>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import saveEle from '@/components/saveEle/saveEle'
import teamquestion from '@/components/teamquestion'
import photo from '@/components/photo/photo'
import { savephone } from '@/data/api'
import pay from '@/components/pay/pay'
export default {
  name: 'Joinpreview',
  data () {
    return {
      imgurl: '', // 没支付的图片
      imgbgurl: '', // 已支付的图片
      chooseKey: '',
      bgcolor: {},
      desc: '',
      id: '1',
      refund_amount: 0,
      is_back: 0,
      saveFlag: false,
      extract_str: '',
      reason: '', // 打回理由
      showFlag: false,
      selObj: {},
      modifyBol: true,
      noops: true,
      photoFlag: false,
      payBol: false, // 是否已经支付
      orderid: '',
      project_no: '',
      payShow: false,
      price: {},
      print_pic_name: [] // 保存排版找图片
    }
  },
  created () {
    console.log('JOINPREVIEW')
    this.initdata()
    this.initmeobj()
  },
  components: {
    saveEle,
    tq: teamquestion,
    photo,
    pay
  },
  methods: {
    ...mapMutations(['setMakePhotoInfo', 'setLoadingTxt']),
    ...mapActions(['getJoindetailA', 'getCollectPayA', 'collectPayA', 'makephoto_v2A']),
    initdata () {
      let {
        add_price,
        basic_price,
        multiple_bg_price
      } = this.default_price

      const {
        wm_url,
        background_color,
        information,
        project_name,
        spec_name,
        color_china,
        extra_information,
        end_time,
        project_no,
        clothes_path,
        refund_amount
      } = this.makePhotoInfo

      if (!wm_url) {
        this.getjoindetail()
        return
      }

      const desc = information ? Object.keys(information).reduce((val, item) => {
        return val + ` ${information[item]}`
      }, '') : ''
      const selObj = {
        project_name,
        spec_name,
        color_china,
        extra_information,
        information,
        end_time
      }
      this.project_no = project_no
      basic_price = this.pto100(basic_price)
      add_price = this.pto100(add_price)
      multiple_bg_price = this.pto100(multiple_bg_price)
      const priceobj = {
        1: basic_price,
        2: add_price,
        4: multiple_bg_price,
        3: basic_price + add_price,
        5: basic_price + multiple_bg_price,
        7: basic_price + add_price + multiple_bg_price
      }
      // 价格
      const price = priceobj
      this.imgurl = wm_url
      this.bgcolor = background_color[0]
      this.desc = desc
      this.selObj = selObj
      this.price = price
      this.refund_amount = refund_amount
      this.chooseKey = clothes_path
      console.log('chooseKey:::', clothes_path)
    },
    pto100 (price) {
      return +(price / 100).toFixed(2)
    },
    onChooseClose (bol) {
      const { chooseKey: datakey, project_no, makePhotoInfo } = this
      const {
        clothes_path,
        wm_url_nofm,
        wm_url,
        algo_fileuuid,
        algo_filename_no_fm,
        leyelarge,
        reyelarge,
        mouthlarge,
        skinwhite,
        skinsoft,
        coseye,
        facelift,
        inputVal,
        wmprinturl,
        wmprinturl_nofm
      } = makePhotoInfo
      const chooseKey = bol ? clothes_path : ''
      if (!algo_filename_no_fm && !chooseKey && datakey) {
        const obj = {
          project_no,
          leyelarge,
          reyelarge,
          mouthlarge,
          skinwhite,
          skinsoft,
          coseye,
          facelift,
          ...inputVal && { inputVal }
        }
        this.makephoto_v2A(obj).then(res => {
          const { algo_fileuuid: af, wm_url: wu } = res
          makePhotoInfo.algo_filename_no_fm = af
          makePhotoInfo.wm_url_nofm = wu
          this.setMakePhotoInfo(makePhotoInfo)
          this.meobj.record = 1
          this.imgurl = wu
          this.chooseKey = chooseKey
        })
        return
      }
      // config中的wm_url和wm_url_zheng来回切换
      const { record } = this.meobj
      this.meobj.record = record === 0 ? 1 : 0
      const wm_url_zheng = bol ? wm_url : wm_url_nofm
      this.imgurl = wm_url_zheng
      this.chooseKey = chooseKey
    },
    onGoPhoto () {
      const obj = this.makePhotoInfo
      obj.needRedirect = true
      this.setMakePhotoInfo(obj)
      this.noops = true
      this.photoFlag = true
      this.showFlag = false
    },
    openflag () {
      this.saveFlag = true
      this.$bus.emit('saveEleShow')
    },
    payOrder () {
      const { refund_amount, is_visible } = this.makePhotoInfo
      if (refund_amount === 1 && is_visible === 0) {
        // 第一次被打回优惠付款
        this.collectpay()
        return
      }
      this.payShow = true
      this.$bus.emit('payInit')
    },
    collectpay () {
      const { clothes_path } = this.makePhotoInfo
      this.collectPayA(clothes_path).then(res => {
        const { order_id, is_pay } = res
        this.orderid = order_id
        if (is_pay === 0) {
          this.iosAction()
          return
        }
        this.getCollectPayA(order_id).then(res => {
          const { trade_no } = res
          this.tradePay(trade_no).then(res => {
            this.iosAction()
          })
        })
      })
    },
    iosAction () {
      this.joinpayHandle()
      Toast({
        message: '已发送至审核者',
        iconClass: 'icon icon-success'
      })
    },
    joinpayHandle () {
      const { project_no, orderid } = this
      // 参与者支付完的操作
      this.$bus.emit('jt_jointeam', project_no, orderid)
      this.getjoindetail()
    },
    rephoto () {
      this.showFlag = true
      this.modifyBol = false
    },
    getjoindetail () {
      this.payBol = true
      const {
        wm_url,
        information,
        project_name,
        spec_name,
        color_china,
        extra_information,
        end_time,
        project_no,
        refund_amount
      } = this.makePhotoInfo
      this.getJoindetailA(project_no).then(res => {
        console.log(res)
        const { data } = res
        const makePhotoInfo = {
          ...this.makePhotoInfo,
          ...data[0]
        }
        this.setMakePhotoInfo(makePhotoInfo)
        const { information, final_pic_name, refuse_reason, order_id, extract_code } = makePhotoInfo
        const desc = information ? Object.keys(information).reduce((val, item) => {
          return val + ` ${information[item]}`
        }, '') : ''
        const selObj = {
          project_name,
          spec_name,
          color_china,
          extra_information,
          information,
          end_time,
          project_no
        }
        this.imgbgurl = final_pic_name[0]
        this.desc = desc
        this.id = order_id
        this.extract_str = extract_code
        this.reason = refuse_reason
        this.refund_amount = refund_amount
        this.selObj = selObj
        this.is_back = data[0].is_back
        this.print_pic_name = data[0].print_pic_name
      })
    },
    initmeobj () {
      this.meobj = {
        record: 0
      }
    },
    onHandleInfo (obj) {
      const { modifyBol } = this
      const fnname = modifyBol ? this.firstsubmit : this.secondsubmit
      fnname.call(this, obj)
    },
    firstsubmit (obj) {
      console.log('obj:::', obj)
      for (const item in obj) {
        if (!obj[item]) {
          Toast(`"${item}"不能为空`)
          return
        }
      }
      const desc = Object.keys(obj).reduce((val, item) => {
        return val + ` ${obj[item]}`
      }, '')
      const makephotoObj = this.makePhotoInfo
      makephotoObj.information = obj
      this.setMakePhotoInfo(makephotoObj)
      this.selObj.information = obj
      this.desc = desc
      this.showFlag = false
    },
    secondsubmit (obj) {
      const { keyname, value } = obj
      const { information = {}, extra_information } = this.selObj
      information[keyname] = value
      !value && delete information[keyname]
      const bol = extra_information.length !== Object.keys(information).length
      this.selObj.information = information
      this.noops = bol
    },
    onCloseWrap () {
      this.noops = true
      this.showFlag = false
    }
  },
  computed: {
    ...mapState(['makePhotoInfo', 'default_price', 'actiBol']),
    teamState () {
      const { end_time: end } = this.selObj
      const endTime = new Date(end).getTime()
      const nowd = new Date()
      const nowTime = new Date(nowd.getFullYear(), nowd.getMonth(), nowd.getDate()).getTime()
      let txt = nowTime > endTime ? '已结束' : '进行中'
      txt = this.is_back === 1 ? '被打回' : txt
      return txt
    }
  }
}
</script>

<style scoped>
button{
    border:none;
}
.joinprediv{
  box-sizing: border-box;
  min-height: 100%;
}
.imgurl{
  width:5.6rem;
  display: block;
  margin:.4rem auto .48rem;
}
.imgurlwrap{
  width:5.6rem;
  margin:.4rem auto .48rem;
}
.imgimg{
  width:100%;
  display: block;
}
.desc{
  word-break: break-all;
  font-size: .34rem;
  color:#303133;
  line-height: .44rem;
  text-align: center;
  width:5rem;
  margin:0 auto .18rem;
}
.foot{
  position: fixed;
  width:100%;
  bottom:0;
  left:0;
  height:1.6rem;
  box-sizing: border-box;
  padding:0 .4rem;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.saveP {
  flex-shrink: 0;
  width: 100%;
  text-align: center;
  color: #4710ED;
  font-size: 0.26rem;
}
.downbtn{
  background-color: #4710ED;
  height:.96rem;
  line-height: .96rem;
  font-size: .34rem;
  color:white;
  border-radius: .12rem;
  flex-grow:1;
}
.retry{
  box-sizing: border-box;
  height:.96rem;
  background-color: white;
  line-height: .96rem;
  font-size: .34rem;
  color:#4710ED;
  border-radius: .12rem;
  border:.04rem solid #4710ED;
  width:49%;
}
.kong{
  width:2%;
  flex-shrink: 0;
}
.info{
  background-color: #FF6C47;
  font-size: .26rem;
  color:#FFFFFF;
  box-sizing: border-box;
  padding:.32rem .4rem;
  line-height: .38rem;
  word-break: break-all;
}
.infotitle{
  font-size: .28rem;
  margin-bottom: .16rem;
}
</style>
